import { createService } from "./createService"
import { SERVICE_INSTANCES } from "./serviceInstances"

const service = createService(SERVICE_INSTANCES.adminPeople)

export const ADMIN_PEOPLE_INSTANCE = service.instanceKey

export const ADMIN_PEOPLE_ENDPOINTS = {
  SELECT: "/admin/people/select",
  SELECT_BY_DEPARTMENT: "/admin/people/selectbydepartment",
  GET_ACTIVE: "/admin/people/get",
  CHECK_EMAIL: "/admin/people/checkemail",
  GET_EMPLOYEES: "/admin/employees/get",
  VIEW_EDIT_EMPLOYEE: "/admin/employees/view/edit",
  VIEW_NEW_ADMIN: "/admin/employees/view/new_admin",
  VIEW_NEW_EMPLOYEE: "/admin/employees/view/new",
  VIEW_REVIEW_EMPLOYEE: "/admin/employees/view/review",
  VIEW_EMPLOYEE_PAYSLIPS: "/admin/employees/view/payslips",
  VIEW_EMPLOYEE_BENEFITS: "/admin/employees/view/benefits",
  VIEW_ADMIN_PAYSLIP_DETAIL: "/payroll_items/view/payslip_admin",
  VIEW_ADMIN_PAYSLIPS: "/payroll_items/view/payslips_admin",
  UPLOAD_IMAGE: "/admin/employees/upload_image",
  DELETE_CUSTOM_FIELD_DOCUMENT: "/admin/employees/delete_customfield_document",
  UPLOAD_CUSTOM_FIELD_DOCUMENT: "/admin/employees/upload_customfield_document",
  SAVE_CUSTOM_FIELD: "/admin/employees/save_customfield",
  VIEW_PERSONAL_INFO: "/admin/employees/view/index_personal_info",
  VIEW_OTHER_INFO: "/admin/employees/view/index_other_info",
  VIEW_CUSTOM_FIELD_INFO: "/admin/employees/view/index_custom_field_info",
  GET_EMPLOYEE_CUSTOM_FIELD: "/admin/custom_fields/getemployeefield",
  VIEW_COMPENSATION_INFO: "/admin/employees/view/index_compensation_info",
  SELECT_VIOLATIONS: "/admin/disciplinary/selectreceivedviolations",
  GET_ORG_CHART: "/admin/people/getorgchart",
  // Employee actions
  ADD_EMPLOYEE: "/admin/employees/add",
  ADD_ADMIN: "/admin/employees/add_admin",
  ADD_MULTIPLE_EMPLOYEES: "/admin/employees/add_multiple",
  SAVE_EDIT_EMPLOYEE: "/admin/employees/save_edit",
  SAVE_REVIEW: "/admin/employees/save_review",
  SAVE_REVIEW_BATCH: "/admin/employees/save_review_batch",
  DELETE: "/admin/employees/delete",
  ADD_PROFILE: "/admin/employees/add_profile",
  REMOVE_PROFILE: "/admin/employees/remove_profile",
  RESET_PASSWORD: "/admin/employees/reset_password",
  CANCEL_SELF_ONBOARDING: "/admin/employees/cancel_self_onboarding",
  SAVE_SELF_ONBOARDING: "/admin/employees/save_self_onboarding",
  BATCH_APPROVE_REVIEW: "/admin/employees/save_review_batch",
  UPDATE_PERSONAL_DETAILS: "/admin/employees/update_personal_details",
  UPDATE_NEXT_OF_KIN: "/admin/employees/update_nextofkin",
  UPDATE_HOME_ADDRESS: "/admin/people/update_homeaddress",
  UPDATE_EMPLOYMENT_DETAIL: "/admin/employees/update_employment_detail",
  UPDATE_TAX: "/admin/employees/update_tax",
  UPDATE_NHF: "/admin/employees/update_nhf",
  UPDATE_NHF_PARTICIPATION: "/admin/employees/update_nhf_participation",
  UPDATE_PENSION_PARTICIPATION: "/admin/employees/update_pension_participation",
  UPDATE_PENSION_EVC: "/admin/employees/update_pension_evc",
  UPDATE_PREFERRED_ACCOUNT: "/admin/employees/update_preferred_account",
  UPDATE_EMPLOYMENT_STATUS: "/admin/employees/update_employment_status",
  UPDATE_OFFICE_ADDRESS: "/admin/employees/update_office_address",
  UPDATE_PAYMENT_METHOD: "/admin/people/update_payment_method",
  UPDATE_SPLIT_PAYMENT_CONFIG: "/admin/employees/update_splitpayment_config",
  UPDATE_COMPENSATION: "/admin/employees/update_compensation",
  ADD_NOTE: "/admin/employees/add_note",
  UPDATE_NOTE: "/admin/employees/update_note",
  DELETE_NOTE: "/admin/employees/delete_note",
  SELECT_FOR_CONFIRMATION: "/admin/people/selectforconfirmation",
  SELECT_EXTERNAL_ADMINS: "/admin/people/selectexternaladmins",
  SELECT_EXITS: "/admin/people/selectexits",
  CONFIRM_EMPLOYEE: "/admin/employees/save_confirm",
  CONFIRM_EMPLOYEE_BATCH: "/admin/employees/save_confirm_batch",
  RESEND_INVITATION: "/admin/employees/resend_invitation",
  REHIRE: "/admin/employees/rehire",
  SELECT_ASSETS: "/admin/employees/selectemployeeassets",
  SELECT_DOCUMENTS: "/admin/employees/selectemployeedocuments",
  SELECT_EXIT_REQUESTS: "/admin/employees/selectexitrequests",
  SELECT_LEAVE_REQUESTS: "/admin/employees/selectleaverequests",
  SELECT_LOAN_REQUESTS: "/admin/employees/selectloanrequests",
  SELECT_REDEPLOYMENT_REQUESTS: "/admin/employees/selectredeploymentrequests",
  SELECT_ADVANCE_REQUESTS: "/admin/employees/selectadvancerequests",
  SELECT_DOCUMENT_REQUESTS: "/admin/employees/selectdocumentrequests",
  SELECT_ONBOARDING_TASKS: "/admin/employees/selectemployeeonboardingtasks",
  SELECT_ROUTINE_TASKS: "/admin/employees/selectemployeeroutinetasks",
  ADD_BENEFITS: "/admin/employees/add_benefits",
  SELECT_REPORTEES: "/employee/people/select_reportees",
  SELECT_LEAVE_BALANCES: "/admin/employees/selectleavebalances",
  GET_CURRENCY_SYMBOL: "/admin/employees/getcurrencysymbol",
  GET_PAYGRADE_HISTORIES: "/admin/employees/getpaygradehistories",
  GET_EMPLOYEE_PAYSLIPS: "/admin/payrolls/getemployeepayslips",
  GET_FOR_SELECTION: "/admin/people/getforselectionwithaccountdetails",
  GET_CONTRACTORS: "/admin/contractors/getforselectionwithaccountdetails",
  GET_FOR_SELECTION_SIMPLE: "/admin/people/getforselection",
  CHECK_ACCOUNT: "/admin/people/checkaccount",
  SELECT_BY_PAYBAND: "/admin/people/selectbypayband",
  SELECT_BY_PAYGRADE: "/admin/people/selectbypaygrade",
  IMPORT_UPDATES: "/admin/employees/importupdates",
  IMPORT_ANNUAL_EARNING: "/admin/employees/import_earning",
  IMPORT_SPLIT_PAYMENT_CONFIG:
    "/admin/employees/import_split_payment_configuration",
  IMPORT_EMPLOYEES: "/admin/employees/import",
  IMPORT_ACCOUNT_DETAILS: "/admin/employees/import_account_details",
  DOWNLOAD_BULK_UPLOAD_FORM_ONLINE:
    "/admin/employees/view/download_bulk_upload_form_online",
  DOWNLOAD_BULK_UPDATE_FORM: "/admin/employees/view/download_bulk_update_form",
  DOWNLOAD_BULK_ACCOUNT_UPLOAD_FORM:
    "/admin/employees/view/download_bulk_account_upload_form",
  DOWNLOAD_BULK_ANNUAL_EARNING_UPLOAD_FORM:
    "/admin/employees/view/download_bulk_annual_earning_upload_form",
  DOWNLOAD_BULK_SPLIT_PAYMENT_UPLOAD_FORM:
    "/admin/employees/view/download_bulk_split_payment_upload_form",
  SELECT_RENT_PAYMENTS: "/admin/employees/selectrentpayments",
  GET_RENT_PAYMENT: "/admin/employees/getrentpayment",
  ADD_RENT_PAYMENT: "/admin/employees/add_rent_payment",
  UPDATE_RENT_PAYMENT: "/admin/employees/update_rent_payment",
  DELETE_RENT_PAYMENT: "/admin/employees/delete_rent_payment",
  BATCH_REVIEW_RENT_PAYMENT: "/admin/employees/batch_review_rent_payment",
  REVIEW_RENT_PAYMENT: "/admin/employees/review_rent_payment",
  VIEW_PERSONAL_INFO_FOR_LOAN:
    "/admin/employees/view/personalinfoforexternalloanrequest",
  VIEW_DASHBOARD: "/admin/view/dashboard",
  SEND_APPLICANT_EMAIL: "/admin/hiring/send_applicant_email",
  GET_JOB_ORGANISATION_AVATAR_URL: "/admin/hiring/getjoborganisationavatarurl",
  SEND_BIRTHDAY_CARD: "/admin/employees/send_birthday_card",
  // Surveys
  SELECT_SURVEYS: "/admin/surveys/select",
  VIEW_SURVEY_INDEX: "/admin/surveys/view/index",
  SELECT_CUSTOM_SURVEY_TEMPLATES: "/admin/surveys/selectcustomtemplates",
  SELECT_DEFAULT_SURVEY_TEMPLATES: "/admin/surveys/selectdefaulttemplates",
  CHECK_SURVEY_TEMPLATE: "/admin/surveys/checktemplate",
  ADD_SURVEY: "/admin/surveys/add",
  FINISH_SURVEY: "/admin/surveys/finish",
  ADD_SURVEY_TEMPLATE: "/admin/surveys/add_template",
  FINISH_SURVEY_TEMPLATE: "/admin/surveys/finish_template",
  ASSIGN_SURVEY: "/admin/surveys/assign",
  REMOVE_SURVEY: "/admin/surveys/remove",
  REMOVE_SURVEY_TEMPLATE: "/admin/surveys/remove_template",
  ADD_SURVEY_QUESTION: "/admin/surveys/add_question",
  DELETE_SURVEY_QUESTION: "/admin/surveys/delete_question",
  EDIT_SURVEY_QUESTION: "/admin/surveys/edit_question",
  ADD_SURVEY_TEMPLATE_QUESTION: "/admin/surveys/add_template_question",
  DELETE_SURVEY_TEMPLATE_QUESTION: "/admin/surveys/delete_template_question",
  EDIT_SURVEY_TEMPLATE_QUESTION: "/admin/surveys/edit_template_question",
  REMOVE_REVIEW_TEMPLATE: "/admin/performance/remove_reviewtemplate",
  // Offers
  SELECT_OFFERS: "/admin/offers/select",
  FINISH_OFFER: "/admin/offers/finish",
  DELETE_OFFER: "/admin/offers/delete",
  RESEND_OFFER: "/admin/offers/resend",
  VIEW_OFFER: "/admin/offers/view",
  VIEW_NEW_OFFER: "/admin/offers/view/new",
  ADD_OFFER: "/admin/offers/add",
  UPDATE_OFFER: "/admin/offers/update",
  SAVE_OFFER_CONTENT: "/admin/offers/save_content",
  ACCEPT_OFFER: "/offer/accept",
  PREVIEW_OFFER: "/offer/preview",
  VIEW_OFFER_BY_CODE: "/offer/view/index",
  // Offer letters (templates)
  GET_OFFER_LETTERS: "/admin/offer_letters/get",
  OL_CHECK: "/admin/offer_letters/checktemplate",
  OL_SAVE: "/admin/offer_letters/save",
  OL_ADD: "/admin/offer_letters/add",
  OL_FINISH: "/admin/offer_letters/finish",
  VIEW_OFFER_LETTER: "/admin/offer_letters/view/details",
  GET_OFFER_LETTER_CONTENT: "/admin/offer_letters/getcontent",
} as const

export const adminPeopleService = {
  instanceKey: service.instanceKey,

  select: (params?: Record<string, any>) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.SELECT, params),
  selectByDepartment: (params?: {
    department_id?: string | number
    pageNumber?: number
    pageSize?: number
    searchParams?: string
    paginate?: boolean
    [key: string]: any
  }) => service.get(ADMIN_PEOPLE_ENDPOINTS.SELECT_BY_DEPARTMENT, params),
  getActive: () =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.GET_ACTIVE, { active: "True" }),
  checkEmail: (email: string) =>
    service.post(ADMIN_PEOPLE_ENDPOINTS.CHECK_EMAIL, { email }),
  checkEmailGet: (email: string, personId?: string | number) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.CHECK_EMAIL, {
      email,
      ...(personId !== undefined ? { person_id: personId } : {}),
    }),
  getEmployees: (params?: Record<string, any>) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.GET_EMPLOYEES, params),
  getContractors: (params?: { currency_code?: string; search?: string }) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.GET_CONTRACTORS, params),
  viewNewEmployee: (params?: Record<string, any>) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.VIEW_NEW_EMPLOYEE, params),
  uploadImage: (formData: FormData, params?: Record<string, any>) =>
    service.upload(ADMIN_PEOPLE_ENDPOINTS.UPLOAD_IMAGE, formData, params),
  deleteCustomFieldDocument: (id: string | number) =>
    service.post(
      `${ADMIN_PEOPLE_ENDPOINTS.DELETE_CUSTOM_FIELD_DOCUMENT}?id=${id}`,
      { id }
    ),
  uploadCustomFieldDocument: (formData: FormData) =>
    service.upload(
      ADMIN_PEOPLE_ENDPOINTS.UPLOAD_CUSTOM_FIELD_DOCUMENT,
      formData
    ),
  saveCustomField: (body: Record<string, any>) =>
    service.post(ADMIN_PEOPLE_ENDPOINTS.SAVE_CUSTOM_FIELD, body),
  getPersonalInfo: (params?: Record<string, any>) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.VIEW_PERSONAL_INFO, params),
  getOtherInfo: (params?: Record<string, any>) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.VIEW_OTHER_INFO, params),
  getCustomFieldInfo: (params?: Record<string, any>) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.VIEW_CUSTOM_FIELD_INFO, params),
  getEmployeeCustomField: (fieldId: string | number, personId: string | number) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.GET_EMPLOYEE_CUSTOM_FIELD, { id: fieldId, person_id: personId }),
  getCompensationInfo: (params?: Record<string, any>) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.VIEW_COMPENSATION_INFO, params),
  selectViolations: (personId: string | number, params?: Record<string, any>) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.SELECT_VIOLATIONS, {
      person_id: personId,
      ...params,
    }),
  getOrgChart: (params?: Record<string, any>) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.GET_ORG_CHART, params),
  selectReportees: (params?: Record<string, any>) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.SELECT_REPORTEES, {
      status: "Active",
      ...params,
    }),

  // Employee actions
  deleteEmployee: (id: string, force?: boolean) =>
    service.post(
      `${ADMIN_PEOPLE_ENDPOINTS.DELETE}?id=${id}${force ? "&force=true" : ""}`
    ),
  addProfile: (id: string) =>
    service.post(`${ADMIN_PEOPLE_ENDPOINTS.ADD_PROFILE}?id=${id}`),
  removeProfile: (id: string) =>
    service.post(`${ADMIN_PEOPLE_ENDPOINTS.REMOVE_PROFILE}?id=${id}`),
  resetPassword: (emails: string[]) =>
    service.post(ADMIN_PEOPLE_ENDPOINTS.RESET_PASSWORD, emails),
  updatePersonalDetails: (body: Record<string, any>) =>
    service.post(ADMIN_PEOPLE_ENDPOINTS.UPDATE_PERSONAL_DETAILS, body),
  updateNextOfKin: (body: Record<string, any>) =>
    service.post(ADMIN_PEOPLE_ENDPOINTS.UPDATE_NEXT_OF_KIN, body),
  updateHomeAddress: (body: Record<string, any>) =>
    service.post(ADMIN_PEOPLE_ENDPOINTS.UPDATE_HOME_ADDRESS, body),
  updateEmploymentDetail: (body: Record<string, any>) =>
    service.post(ADMIN_PEOPLE_ENDPOINTS.UPDATE_EMPLOYMENT_DETAIL, body),
  updateTax: (body: Record<string, any>) =>
    service.post(ADMIN_PEOPLE_ENDPOINTS.UPDATE_TAX, body),
  updateNhf: (body: Record<string, any>) =>
    service.post(ADMIN_PEOPLE_ENDPOINTS.UPDATE_NHF, body),
  updateNhfParticipation: (body: Record<string, any>) =>
    service.post(ADMIN_PEOPLE_ENDPOINTS.UPDATE_NHF_PARTICIPATION, body),
  updatePensionParticipation: (body: Record<string, any>) =>
    service.post(ADMIN_PEOPLE_ENDPOINTS.UPDATE_PENSION_PARTICIPATION, body),
  updatePensionEvc: (body: Record<string, any>) =>
    service.post(ADMIN_PEOPLE_ENDPOINTS.UPDATE_PENSION_EVC, body),
  updatePreferredAccount: (body: Record<string, any>) =>
    service.post(ADMIN_PEOPLE_ENDPOINTS.UPDATE_PREFERRED_ACCOUNT, body),
  updateEmploymentStatus: (body: Record<string, any>) =>
    service.post(ADMIN_PEOPLE_ENDPOINTS.UPDATE_EMPLOYMENT_STATUS, body),
  updateOfficeAddress: (body: Record<string, any>) =>
    service.post(ADMIN_PEOPLE_ENDPOINTS.UPDATE_OFFICE_ADDRESS, body),
  updatePaymentMethod: (body: Record<string, any>) =>
    service.post(ADMIN_PEOPLE_ENDPOINTS.UPDATE_PAYMENT_METHOD, body),
  updateSplitPaymentConfig: (body: Record<string, any>) =>
    service.post(ADMIN_PEOPLE_ENDPOINTS.UPDATE_SPLIT_PAYMENT_CONFIG, body),
  updateAccount: (type: "primary" | "secondary", body: Record<string, any>) =>
    service.post(`/admin/employees/update_${type}_account`, body),
  addNote: (id: string | number, note: string) =>
    service.post(
      `${ADMIN_PEOPLE_ENDPOINTS.ADD_NOTE}?id=${id}&note=${encodeURIComponent(
        note
      )}`
    ),
  updateNote: (id: string | number, note: string) =>
    service.post(
      `${ADMIN_PEOPLE_ENDPOINTS.UPDATE_NOTE}?id=${id}&note=${encodeURIComponent(
        note
      )}`
    ),
  deleteNote: (id: string | number) =>
    service.post(`${ADMIN_PEOPLE_ENDPOINTS.DELETE_NOTE}?id=${id}`),
  selectNeedsAttention: (params?: {
    pageNumber?: number
    pageSize?: number
    searchParams?: string
  }) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.SELECT, {
      type: "Attention",
      search: params?.searchParams ?? "",
      pageNumber: params?.pageNumber ?? 1,
      pageSize: params?.pageSize ?? 20,
    }),
  selectExternalAdmins: (params?: {
    pageNumber?: number
    pageSize?: number
    searchParams?: string
  }) => service.get(ADMIN_PEOPLE_ENDPOINTS.SELECT_EXTERNAL_ADMINS, params),
  batchApproveReview: (sendEmail: string) =>
    service.post(ADMIN_PEOPLE_ENDPOINTS.SAVE_REVIEW_BATCH, {
      send_email: sendEmail,
    }),
  cancelSelfOnboarding: (id: string) =>
    service.post(`${ADMIN_PEOPLE_ENDPOINTS.CANCEL_SELF_ONBOARDING}?id=${id}`),
  saveSelfOnboarding: (personId: string | number, body: Record<string, any>) =>
    service.post(
      `${ADMIN_PEOPLE_ENDPOINTS.SAVE_SELF_ONBOARDING}?id=${personId}`,
      body
    ),
  sendOrResendInvitation: (id: string, type: "send" | "resend") =>
    service.post(`/admin/employees/${type}_invitation?id=${id}`),
  bulkDeleteEmployees: (ids: string[]) =>
    service.post(`/admin/employees/bulk_delete`, ids),
  selectForConfirmation: (params?: {
    pageNumber?: number
    pageSize?: number
    searchParams?: string
    departmentId?: string | number
  }) => service.get(ADMIN_PEOPLE_ENDPOINTS.SELECT_FOR_CONFIRMATION, params),
  confirmEmployee: (body: Record<string, any>) =>
    service.post(ADMIN_PEOPLE_ENDPOINTS.CONFIRM_EMPLOYEE, body),
  confirmAllEmployees: () =>
    service.post(ADMIN_PEOPLE_ENDPOINTS.CONFIRM_EMPLOYEE_BATCH),
  resendInvitation: (ids: string[]) =>
    service.post(ADMIN_PEOPLE_ENDPOINTS.RESEND_INVITATION, ids),
  importUpdates: (formData: FormData) =>
    service.upload(ADMIN_PEOPLE_ENDPOINTS.IMPORT_UPDATES, formData),
  importAnnualEarning: (formData: FormData) =>
    service.upload(ADMIN_PEOPLE_ENDPOINTS.IMPORT_ANNUAL_EARNING, formData),
  importSplitPaymentConfig: (formData: FormData) =>
    service.upload(
      ADMIN_PEOPLE_ENDPOINTS.IMPORT_SPLIT_PAYMENT_CONFIG,
      formData
    ),
  viewNewAdmin: (id: string) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.VIEW_NEW_ADMIN, { id }),
  viewEditEmployee: (id: string) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.VIEW_EDIT_EMPLOYEE, { id }),
  addEmployee: (body: Record<string, any>) =>
    service.post(ADMIN_PEOPLE_ENDPOINTS.ADD_EMPLOYEE, body),
  addAdmin: (body: Record<string, any>) =>
    service.post(ADMIN_PEOPLE_ENDPOINTS.ADD_ADMIN, body),
  saveEditEmployee: (id: string | number, body: Record<string, any>) =>
    service.post(`${ADMIN_PEOPLE_ENDPOINTS.SAVE_EDIT_EMPLOYEE}?id=${id}`, body),
  selectAssets: (personId: string | number, params?: Record<string, any>) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.SELECT_ASSETS, {
      person_id: personId,
      ...params,
    }),
  selectDocuments: (
    personId: string | number,
    params?: { searchParams?: string; pageNumber?: number; pageSize?: number }
  ) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.SELECT_DOCUMENTS, {
      person_id: personId,
      ...params,
    }),
  selectExitRequests: (
    personId: string | number,
    params?: { searchParams?: string; pageNumber?: number; pageSize?: number }
  ) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.SELECT_EXIT_REQUESTS, {
      person_id: personId,
      ...params,
    }),
  selectLeaveRequests: (
    personId: string | number,
    params?: { searchParams?: string; pageNumber?: number; pageSize?: number }
  ) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.SELECT_LEAVE_REQUESTS, {
      person_id: personId,
      ...params,
    }),
  selectLoanRequests: (
    personId: string | number,
    params?: { searchParams?: string; pageNumber?: number; pageSize?: number }
  ) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.SELECT_LOAN_REQUESTS, {
      person_id: personId,
      ...params,
    }),
  selectRedeploymentRequests: (
    personId: string | number,
    params?: { searchParams?: string; pageNumber?: number; pageSize?: number }
  ) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.SELECT_REDEPLOYMENT_REQUESTS, {
      person_id: personId,
      ...params,
    }),
  selectAdvanceRequests: (
    personId: string | number,
    params?: { searchParams?: string; pageNumber?: number; pageSize?: number }
  ) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.SELECT_ADVANCE_REQUESTS, {
      person_id: personId,
      ...params,
    }),
  selectDocumentRequests: (
    personId: string | number,
    params?: { searchParams?: string; pageNumber?: number; pageSize?: number }
  ) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.SELECT_DOCUMENT_REQUESTS, {
      person_id: personId,
      ...params,
    }),
  addBenefits: (personId: string, body: Record<string, any>[]) =>
    service.post(`${ADMIN_PEOPLE_ENDPOINTS.ADD_BENEFITS}?id=${personId}`, body),
  selectLeaveBalances: (
    personId: string | number,
    params?: { searchParams?: string; pageNumber?: number; pageSize?: number }
  ) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.SELECT_LEAVE_BALANCES, {
      person_id: personId,
      ...params,
    }),
  getCurrencySymbol: (personId: string | number) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.GET_CURRENCY_SYMBOL, { id: personId }),
  getForSelection: (params?: Record<string, any>) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.GET_FOR_SELECTION, params),
  getForSelectionSimple: (params?: Record<string, any>) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.GET_FOR_SELECTION_SIMPLE, params),
  getPersonalInfoForLoan: (id: string | number) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.VIEW_PERSONAL_INFO_FOR_LOAN, { id }),
  getDashboard: () => service.get(ADMIN_PEOPLE_ENDPOINTS.VIEW_DASHBOARD),
  selectByPayband: (
    paybandId: string | number,
    params?: {
      pageNumber?: number
      pageSize?: number
      searchParams?: string
      [key: string]: any
    }
  ) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.SELECT_BY_PAYBAND, {
      payband_id: paybandId,
      ...params,
    }),
  selectByPaygrade: (paygradeId: string | number) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.SELECT_BY_PAYGRADE, {
      paygrade_id: paygradeId,
    }),
  importEmployees: (formData: FormData, invite?: boolean) =>
    service.upload(
      `${ADMIN_PEOPLE_ENDPOINTS.IMPORT_EMPLOYEES}${
        invite !== undefined ? `?invite=${invite ? "yes" : "no"}` : ""
      }`,
      formData
    ),
  importAccountDetails: (formData: FormData) =>
    service.upload(ADMIN_PEOPLE_ENDPOINTS.IMPORT_ACCOUNT_DETAILS, formData),
  addMultipleEmployees: (body: any, invite?: boolean) =>
    service.post(
      `${ADMIN_PEOPLE_ENDPOINTS.ADD_MULTIPLE_EMPLOYEES}${
        invite !== undefined ? `?invite=${invite ? "yes" : "no"}` : ""
      }`,
      body
    ),
  viewReviewEmployee: (id: string | number) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.VIEW_REVIEW_EMPLOYEE, { id }),
  saveReview: (personId: string | number, body: Record<string, any>) =>
    service.post(`${ADMIN_PEOPLE_ENDPOINTS.SAVE_REVIEW}?id=${personId}`, body),
  getPaygradeHistories: () =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.GET_PAYGRADE_HISTORIES),
  updateCompensation: (body: Record<string, any>) =>
    service.post(ADMIN_PEOPLE_ENDPOINTS.UPDATE_COMPENSATION, body),
  checkAccount: (
    accountNumber: string,
    entityType: string,
    entityId: string | number
  ) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.CHECK_ACCOUNT, {
      account_number: accountNumber,
      entity_type: entityType,
      contractor_id: entityId,
    }),
  selectRentPayments: (
    filters: { personId?: string | number; statusId?: number },
    params?: {
      pageNumber?: number
      pageSize?: number
      searchParams?: string
      [key: string]: any
    }
  ) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.SELECT_RENT_PAYMENTS, {
      ...filters,
      ...params,
    }),
  getRentPayment: (id: string) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.GET_RENT_PAYMENT, { id }),
  addAdminRentPayment: (formData: FormData) =>
    service.upload(ADMIN_PEOPLE_ENDPOINTS.ADD_RENT_PAYMENT, formData),
  updateAdminRentPayment: (id: string | number, formData: FormData) =>
    service.upload(
      `${ADMIN_PEOPLE_ENDPOINTS.UPDATE_RENT_PAYMENT}?id=${id}`,
      formData
    ),
  deleteRentPayment: (id: string | number) =>
    service.post(`${ADMIN_PEOPLE_ENDPOINTS.DELETE_RENT_PAYMENT}?id=${id}`, {}),
  batchReviewRentPayment: (
    action: string,
    payload: { employee_rent_id: string; note: string }[]
  ) =>
    service.post(
      `${ADMIN_PEOPLE_ENDPOINTS.BATCH_REVIEW_RENT_PAYMENT}?action=${action}`,
      payload as any
    ),
  reviewRentPayment: (id: string | number, body: Record<string, any>) =>
    service.post(
      `${ADMIN_PEOPLE_ENDPOINTS.REVIEW_RENT_PAYMENT}?id=${id}`,
      body
    ),
  getEmployeePayslips: (personId: string | number) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.GET_EMPLOYEE_PAYSLIPS, { id: personId }),
  viewEmployeePayslips: (id: string | number, year?: number) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.VIEW_EMPLOYEE_PAYSLIPS, { id, x: year }),
  viewEmployeeBenefits: (id: string | number) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.VIEW_EMPLOYEE_BENEFITS, { id }),
  viewAdminPayslipDetail: (id: string | number, x: string | number) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.VIEW_ADMIN_PAYSLIP_DETAIL, { id, x }),
  viewAdminPayslips: (id: string | number, x: string | number) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.VIEW_ADMIN_PAYSLIPS, { id, x }),
  selectOnboardingTasks: (
    personId: string | number,
    params?: { searchParams?: string; pageNumber?: number; pageSize?: number }
  ) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.SELECT_ONBOARDING_TASKS, {
      person_id: personId,
      ...params,
    }),
  selectRoutineTasks: (
    personId: string | number,
    params?: { searchParams?: string; pageNumber?: number; pageSize?: number }
  ) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.SELECT_ROUTINE_TASKS, {
      person_id: personId,
      ...params,
    }),
  selectExits: (params?: {
    searchParams?: string
    pageNumber?: number
    pageSize?: number
  }) => service.get(ADMIN_PEOPLE_ENDPOINTS.SELECT_EXITS, params),
  rehireEmployee: (id: string | number) =>
    service.post(`${ADMIN_PEOPLE_ENDPOINTS.REHIRE}?id=${id}`),
  sendApplicantEmail: (body: Record<string, any>) =>
    service.post(ADMIN_PEOPLE_ENDPOINTS.SEND_APPLICANT_EMAIL, body),
  getJobOrganisationAvatarUrl: (padeCompanyId: string | number) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.GET_JOB_ORGANISATION_AVATAR_URL, {
      pade_company_id: padeCompanyId,
    }),
  sendBirthdayCard: (personId: string | number) =>
    service.post(`${ADMIN_PEOPLE_ENDPOINTS.SEND_BIRTHDAY_CARD}?id=${personId}`),

  // Surveys
  selectSurveys: (params: Record<string, any>) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.SELECT_SURVEYS, params),
  viewSurveyIndex: (params: Record<string, any>) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.VIEW_SURVEY_INDEX, params),
  selectCustomSurveyTemplates: (params: Record<string, any>) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.SELECT_CUSTOM_SURVEY_TEMPLATES, params),
  selectDefaultSurveyTemplates: (params: Record<string, any>) =>
    service.get(
      ADMIN_PEOPLE_ENDPOINTS.SELECT_DEFAULT_SURVEY_TEMPLATES,
      params
    ),
  checkSurveyTemplate: (
    description: string,
    surveyTemplateId: string | number,
    typeId: string | number
  ) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.CHECK_SURVEY_TEMPLATE, {
      description,
      survey_template_id: surveyTemplateId,
      survey_template_type_id: typeId,
    }),
  addSurvey: (body: Record<string, any>) =>
    service.post(ADMIN_PEOPLE_ENDPOINTS.ADD_SURVEY, body),
  finishSurvey: (body: Record<string, any>) =>
    service.post(ADMIN_PEOPLE_ENDPOINTS.FINISH_SURVEY, body),
  addSurveyTemplate: (body: Record<string, any>) =>
    service.post(ADMIN_PEOPLE_ENDPOINTS.ADD_SURVEY_TEMPLATE, body),
  finishSurveyTemplate: (body: Record<string, any>) =>
    service.post(ADMIN_PEOPLE_ENDPOINTS.FINISH_SURVEY_TEMPLATE, body),
  assignSurvey: (id: string | number, body: Record<string, any>[]) =>
    service.post(
      `${ADMIN_PEOPLE_ENDPOINTS.ASSIGN_SURVEY}?id=${id}`,
      body as any
    ),
  removeSurvey: (id: string | number) =>
    service.post(`${ADMIN_PEOPLE_ENDPOINTS.REMOVE_SURVEY}?id=${id}`, {}),
  removeSurveyTemplate: (id: string | number) =>
    service.post(
      `${ADMIN_PEOPLE_ENDPOINTS.REMOVE_SURVEY_TEMPLATE}?id=${id}`,
      {}
    ),
  addSurveyQuestion: (
    id: string | number,
    params: {
      description: string
      alias: string
      response_type_id: string
      response_option?: string
    }
  ) =>
    service.post(
      `${ADMIN_PEOPLE_ENDPOINTS.ADD_SURVEY_QUESTION}?id=${id}&description=${
        params.description
      }&alias=${params.alias}&response_type_id=${
        params.response_type_id
      }&response_option=${params.response_option}`,
      {}
    ),
  deleteSurveyQuestion: (id: string | number) =>
    service.post(
      `${ADMIN_PEOPLE_ENDPOINTS.DELETE_SURVEY_QUESTION}?id=${id}`,
      {}
    ),
  editSurveyQuestion: (
    id: string | number,
    params: {
      description: string
      alias: string
      response_type_id: string
      response_option?: string
    }
  ) =>
    service.post(
      `${ADMIN_PEOPLE_ENDPOINTS.EDIT_SURVEY_QUESTION}?id=${id}&description=${
        params.description
      }&alias=${params.alias}&response_type_id=${
        params.response_type_id
      }&response_option=${params.response_option}`,
      {}
    ),
  addSurveyTemplateQuestion: (
    id: string | number,
    params: {
      description: string
      alias: string
      response_type_id: string
      response_option?: string
    }
  ) =>
    service.post(
      `${
        ADMIN_PEOPLE_ENDPOINTS.ADD_SURVEY_TEMPLATE_QUESTION
      }?id=${id}&description=${params.description}&alias=${
        params.alias
      }&response_type_id=${params.response_type_id}&response_option=${
        params.response_option
      }`,
      {}
    ),
  deleteSurveyTemplateQuestion: (id: string | number) =>
    service.post(
      `${ADMIN_PEOPLE_ENDPOINTS.DELETE_SURVEY_TEMPLATE_QUESTION}?id=${id}`,
      {}
    ),
  editSurveyTemplateQuestion: (
    id: string | number,
    params: {
      description: string
      alias: string
      response_type_id: string
      response_option?: string
    }
  ) =>
    service.post(
      `${
        ADMIN_PEOPLE_ENDPOINTS.EDIT_SURVEY_TEMPLATE_QUESTION
      }?id=${id}&description=${params.description}&alias=${
        params.alias
      }&response_type_id=${params.response_type_id}&response_option=${
        params.response_option
      }`,
      {}
    ),
  removeReviewTemplate: (id: string | number) =>
    service.post(
      `${ADMIN_PEOPLE_ENDPOINTS.REMOVE_REVIEW_TEMPLATE}?id=${id}`,
      {}
    ),

  // Offers — listing (search + pagination live on the endpoint)
  selectOffers: (statusId: string | number, params?: Record<string, any>) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.SELECT_OFFERS, { statusId, ...params }),
  finishOffer: (body: Record<string, any>) =>
    service.post(ADMIN_PEOPLE_ENDPOINTS.FINISH_OFFER, body),
  deleteOffer: (id: string | number) =>
    service.post(`${ADMIN_PEOPLE_ENDPOINTS.DELETE_OFFER}?id=${id}`),
  resendOffer: (id: string | number) =>
    service.post(`${ADMIN_PEOPLE_ENDPOINTS.RESEND_OFFER}?id=${id}`),
  viewOffer: (key: string) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.VIEW_OFFER, { id: key }),
  viewNewOffer: (key: string) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.VIEW_NEW_OFFER, { id: key, x: key }),
  viewNewOfferByToken: (x: string) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.VIEW_NEW_OFFER, { x }),
  addOffer: (body: Record<string, any>) =>
    service.post(ADMIN_PEOPLE_ENDPOINTS.ADD_OFFER, body),
  updateOffer: (id: string | number, body: Record<string, any>) =>
    service.post(`${ADMIN_PEOPLE_ENDPOINTS.UPDATE_OFFER}?id=${id}`, body),
  saveOfferContent: (offerId: string, content: string) =>
    service.post(ADMIN_PEOPLE_ENDPOINTS.SAVE_OFFER_CONTENT, {
      offer_id: offerId,
      content,
    }),
  acceptOffer: (body: Record<string, any>, accessToken?: string) =>
    service.post(
      ADMIN_PEOPLE_ENDPOINTS.ACCEPT_OFFER,
      body,
      accessToken ? { Authorization: `Bearer ${accessToken}` } : undefined
    ),
  previewOffer: (key: string) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.PREVIEW_OFFER, { id: key }),
  viewOfferByCode: (userId: string, code: string) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.VIEW_OFFER_BY_CODE, {
      uId: userId,
      code,
    }),

  // Offer letters (templates)
  getOfferLetters: (id?: string | number) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.GET_OFFER_LETTERS, { id }),
  checkOfferLetterTemplate: (description: string, templateId: string) =>
    service.get(
      `${ADMIN_PEOPLE_ENDPOINTS.OL_CHECK}?description=${encodeURIComponent(
        description
      )}&document_template_id=${templateId}`
    ),
  saveOfferLetterTemplate: (body: Record<string, any>) =>
    service.post(ADMIN_PEOPLE_ENDPOINTS.OL_SAVE, body),
  addOfferLetterTemplate: (body: Record<string, any>) =>
    service.post(ADMIN_PEOPLE_ENDPOINTS.OL_ADD, body),
  finishOfferLetterTemplate: (body: Record<string, any>) =>
    service.post(ADMIN_PEOPLE_ENDPOINTS.OL_FINISH, body),
  viewOfferLetter: (id: string | number) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.VIEW_OFFER_LETTER, { id }),
  getOfferLetterContent: (templateId: string | number) =>
    service.get(ADMIN_PEOPLE_ENDPOINTS.GET_OFFER_LETTER_CONTENT, {
      document_template_id: templateId,
    }),
}
